import React, {useEffect} from 'react';
import {Toolbar} from "./components/Toolbar";
import {NavBar} from "./components/NavBar";
import './App.css';
import firebase from 'firebase/app';

firebase.initializeApp({
    apiKey: "AIzaSyDtgH9jhAMNP-ptFfakgtbSD-r7ajJj9nM",
    authDomain: "wa-orth.firebaseapp.com",
    databaseURL: "https://wa-orth-default-rtdb.firebaseio.com",
    projectId: "wa-orth",
    storageBucket: "wa-orth.appspot.com",
    messagingSenderId: "753563607175",
    appId: "1:753563607175:web:6d4f5e8fda106f68eed822",
    measurementId: "G-52BWRS4Z8P"
})

function App() {
    useEffect(() => {
        document.getElementById("root").onwheel = function(e){
            e.preventDefault()
        }
        let canvas = document.getElementById("canvas")
        window.onresize = function(e){
            let w = canvas.clientWidth;
            let h = canvas.clientHeight;
            if(w !== canvas.width || h !== canvas.height){
                canvas.width = w;
                canvas.height = h;
            }
            window.Module.ready.then(api => api.set_size(w,h))
        }
        canvas.onmousemove = function(e){
            let curX = e.pageX - canvas.offsetLeft;
            let curY = e.pageY - canvas.offsetTop;
            document.getElementById('xcoord').innerHTML = curX;
            document.getElementById('ycoord').innerHTML = curY;
        }
    },[])

    return (
        <>
            <NavBar/>
            <Toolbar/>
        </>
    );
}

export default App;